import React from 'react';
import { Box, Typography } from '@material-ui/core';
import ChildFriendly from '@material-ui/icons/ChildFriendly'
import { useTranslation } from 'react-i18next';

import { RepLISlider } from "../../../components";

import ChildrenQtySelect from './ChildrenQtySelect';

import styles from "./styles";

export const CurrentChildrenQty = (props) => {
    const classes = styles();
    const { t } = useTranslation();

    return (
        <>
            <Box className={classes.iconSection}>
                <ChildFriendly className={classes.icon} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('fpqQuestionnaire.currentChildrenQuestion')}
                </Typography>
            </Box>
            <Box className={classes.inputSection}>
                <ChildrenQtySelect value={props.currentChildrenQty} onQtyChange={props.onCurrentChildrenQtyChange} />
            </Box>
            {
                props.currentChildrenQty > 0 &&
                <>
                    <Box className={classes.textSection}>
                        <Typography component="div" className={classes.text}>
                            How many of your children are biological?
                        </Typography>
                    </Box>
                    <Box className={classes.inputSection}>
                        <RepLISlider
                            defaultValue={0}
                            value={props.biologicalChildrenQty}
                            valueLabelDisplay="on"
                            step={1}
                            marks
                            min={0}
                            max={props.currentChildrenQty}
                            onChange={props.onBiologicalChildrenQtyChange}
                        />
                    </Box>
                </>
            }
        </>
    );
};

export default CurrentChildrenQty;